<template>
  <section class="app-members__section">
    <AppHeading tag="h4" :text="title" />
    <div v-if="users" class="app-members__listing">
      <UserAvatar
        v-for="user in users"
        :key="user.id"
        :user="user"
        @click.native="userSelected(user)"
      />
    </div>
    <AppLoadingProgressBars v-else height="20px" width="2px" />
  </section>
</template>

<script>
// Components
import AppHeading from 'Ui/AppHeading'
import UserAvatar from 'Components/UserAvatar'
import AppLoadingProgressBars from 'Ui/AppLoadingProgressBars'

export default {
  name: 'AppMembersSection',

  components: {
    UserAvatar,
    AppHeading,
    AppLoadingProgressBars,
  },

  props: {
    users: {
      type: Array,
      default: () => [],
    },

    title: {
      type: String,
      defaul: '',
    },
  },

  methods: {
    userSelected(user) {
      this.$emit('selected', user)
    },
  },
}
</script>

<style scoped>
.app-members__section {
  min-width: 240px;
}

.app-members__section:not(:first-of-type) {
  margin-top: 20px;
}

.app-members__listing {
  display: flex;
  flex-flow: row wrap;
  gap: 10px;
  margin-top: 10px;
}
</style>
